import React, { useEffect, useState } from 'react';

type Props = {
  from?: number;
};

export const CountDown = ({ from = 3 }: Props) => {
  const [count, setCount] = useState(from);

  useEffect(() => {
    if (count > 0) {
      const timer = setTimeout(() => setCount(count - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [count]);

  return <span>{count.toString()}</span>;
};
